import React, { useCallback, useEffect, useState } from 'react';
import { flowRight as compose } from 'lodash';
import { useDispatch } from 'react-redux';
import getAllReservationQuery from './getAllReservationQuery.graphql';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ReservationContainer.css';
import bt from '../../components/commonStyle.css';
// Component
import ManageReservation from '../../components/ManageReservation/ManageReservation';
import { onChangeListing } from '../../actions/Listing/onChangeListing';
import { withQuery } from '../../hoc/withGraphql';

const ReservationContainer = ({ type, data }) => {

  const [currentPage, setCurrentPage] = useState();
  const [listId, setListId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [orderBy, setOrderBy] = useState(null);
  const [searchKey, setSearchKey] = useState('');
  const [userType, setUserType] = useState('host');
  const [dateFilter, setDateFilter] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(onChangeListing({
      listId: null,
      startDate: null,
      endDate: null,
      orderBy: null,
    }));

    setDateFilter(type);
    setCurrentPage(1);
  }, [searchKey])

  const setStateVariable = useCallback((variables) => {
    if ('currentPage' in variables) setCurrentPage(variables.currentPage);
    if ('listId' in variables) setListId(variables.listId);
    if ('startDate' in variables) setStartDate(variables.startDate);
    if ('endDate' in variables) setEndDate(variables.endDate);
    if ('orderBy' in variables) setOrderBy(variables.orderBy);
    if ('searchKey' in variables) setSearchKey(variables.searchKey);
    if ('userType' in variables) setUserType(variables.userType);
    if ('dateFilter' in variables) setDateFilter(variables.dateFilter);
  }, [
    currentPage,
    listId,
    startDate,
    endDate,
    orderBy,
    searchKey,
    userType,
    dateFilter
  ])

  return <ManageReservation
    searchKey={searchKey}
    currentPage={currentPage}
    listId={listId}
    startDate={startDate}
    endDate={endDate}
    orderBy={orderBy}
    dateFilter={dateFilter || type}
    type={type}
    userType={userType}
    setStateVariable={setStateVariable}
    data={data}
  />;
}

export default compose(
  withStyles(s, bt),
  withQuery(getAllReservationQuery,
    {
      options: (props) => ({
        variables: {
          currentPage: 1,
          listId: null,
          startDate: null,
          endDate: null,
          orderBy: null,
          searchKey: '',
          userType: 'host',
          dateFilter: props.type,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(ReservationContainer);
